module.exports = __webpack_public_path__ + "img/user.973cc780.svg";